import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { CircularProgress } from '@mui/material';
import './reports.css';

import {
  getLastUserInfo,
  getUrlVariables,
  findIndexInArray,
} from 'js/library/utils/helpers';
import {
  checkUserStatus,
  logout,
} from 'js/library/services/AuthenticationManager.js';
import { getUserInfoBasic_v1 } from 'js/library/utils/API/getUserInfo_v1.js';
import CodeInput from '../LoginForms/CodeInput';
import { authCode } from 'js/library/utils/API/authCode';

import { models } from 'powerbi-client';
import getPowerBI from 'js/library/utils/API/getPowerBI';
import { PowerBIEmbed } from 'powerbi-client-react';
import { useState } from 'react';

export default function Reports() {
  const [transactionId, setTransactionId] = useState('');
  const [cellPhone, setCellPhone] = useState('');
  //const [urlGraphics, setUrlGraphics] = useState('');
  const [embedUrl] = useState('');
  const [openGraphics, setOpenGraphics] = useState(false);
  const [reportId, setReportId] = useState(null);
  const [reportList, setReportList] = useState([]);
  const [accessToken, setAccessToken] = useState(null);

  //verificações
  const [smsSender, setSmsSender] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [error, setError] = useState(false);
  const [reload, setReload] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    const userInfo = getLastUserInfo();
    const urlVars = getUrlVariables();

    checkUserStatus()
      .then(async (resp) => {
        if (resp !== null) {
          if (resp.uid === userInfo.uId && resp.uid === urlVars.uid) {
            getPowerBI(urlVars.configId, urlVars.uid)
              .then((response) => {
                let list = [];
                if (response.success) {
                  response.embedInfo.forEach((item) => {
                    let data = {
                      ...item.embedUrl[0],
                      accessToken: item.accessToken,
                    };
                    list.push(data);
                  });
                }
                //setUrlGraphics(response.embedInfo[0].embedUrl[0].embedUrl);
                setReportId(response.embedInfo[0].embedUrl[0].reportId);
                setAccessToken(response.embedInfo[0].accessToken);
                setOpenGraphics(true);
                setReportList(list);
              })
              .catch((e) => {
                setErrorMsg(t('errors.no_BI_permission'));
                setError(true);
              });
          } else {
            //uid da URL diferente da conta logada - deslogando o usuário e logando na conta da URL
            await logout();
            setReload(!reload);
          }
        } else {
          setErrorMsg(t('errors.user_not_logged_in'));

          localStorage.setItem('loginOption', 3);
          localStorage.setItem(
            'loginRedirect',
            window.location.pathname + window.location.search
          );
          getUserInfoBasic_v1(['getUserInfo'], {
            uId: urlVars.uid,
          }).then((response) => {
            let cellPhone =
              response.contactList[
                findIndexInArray(response.contactList, 'type', 'cellPhone')
              ].value;

              authCode(cellPhone).then((auth) => {
              setTransactionId(auth.transactionId);
              setCellPhone(cellPhone);
              setSmsSender(true);
            });
          });
        }
      })
      .catch((e) => {
        //console.log(e);
      });
  }, [t, reload]);

  const filterGraphic = (reportId) => {
    setOpenGraphics(false);
    if (reportId !== '') {
      const selectedGraphic = reportList.filter(
        (item) => item.reportId === reportId
      );
      if (selectedGraphic.length > 0) {
        //setUrlGraphics(selectedGraphic[0].embedUrl);
        setReportId(selectedGraphic[0].reportId);
        setAccessToken(selectedGraphic[0].accessToken);
        setOpenGraphics(true);
      }
    }
  };

  return (
    <div>
      {reportList.length > 0 && (
        <select
          name="Reports BI"
          className="selectBi"
          onChange={(event) => filterGraphic(event.target.value)}
        >
          {reportList.map((item, index) => {
            return (
              <option key={index} value={item.reportId}>
                {item.reportName}
              </option>
            );
          })}
        </select>
      )}
      <div className="labelSelect">{t('general.select_campaign')}</div>

      <div
        style={{
          height: '72vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {smsSender ? (
          <CodeInput
            cellPhoneProps={cellPhone}
            transactionIdProps={transactionId}
          />
        ) : openGraphics ? (
          <PowerBIEmbed
            cssClassName="iframe-powerBI"
            key={reportId}
            embedConfig={{
              type: 'report', // Supported types: report, dashboard, tile, visual and qna
              id: reportId,
              embedUrl: embedUrl,
              accessToken: accessToken, // Keep as empty string, null or undefined
              tokenType: models.TokenType.Embed,
            }}
          />
        ) : // <iframe src={ urlGraphics} title="powerBI" className="iframe-powerBI" style={{ width: '100%', minHeight: '88vh' }}></iframe>
        error ? (
          errorMsg
        ) : (
          <CircularProgress />
        )}
      </div>
    </div>
  );
}
